<template>
    <Select :model-value="modelValue" data-testid="section-select" @onChange="onChange">
        <Option v-for="option in sectionOptions" :key="option.value" :value="option.value">
            {{ option.label }}
        </Option>
    </Select>
</template>

<script lang="ts">
import type { PropType } from "vue";
import type { CampaignSection } from "@/types/types";

export default {
    props: {
        sections: {
            required: true,
            type: Array as PropType<CampaignSection[]>
        },

        modelValue: {
            type: [Number, String],
            default: "none"
        }
    },

    emits: ["update:modelValue"],

    computed: {
        sectionOptions() {
            return [
                {
                    label: "None",
                    /*
                        Ideally this value would be `null` or `undefined` but the iView
                        select component will not select it as an initial value if we
                        use those values.
                    */
                    value: "none"
                },
                ...this.sections.map(section => ({
                    label: section.name,
                    value: section._id
                }))
            ];
        }
    },

    methods: {
        onChange(value: string) {
            this.$emit("update:modelValue", value);
        }
    }
};
</script>
